const default_colors = { 
    0: 'No Sock', 
    1: 'Navy', 
    2: 'Scarlet', 
    3: 'Columbia Blue', 
    4: 'Grey', 
    5: 'Graphite' 
};

const colors = {
    'Air Force Blue': '%23006699', 
    'Black': '%23000000', 
    'Brown': '%2365431f', 
    'Bright Yellow': '%23ffff66',
    'Cardinal': '%23871728',
    'Columbia Blue': '%236699cc',
    'Cream': '%23FCFBE3',
    'Dark Gold': '%23ffcc33',
    'Dark Green': '%23005e35',
    'Dark Navy': '%23001D45',
    'Dark Royal': '%2300519c', 
    'Fuchsia': '%23dc81bb',
    'Gold': '%23FBCB13', 
    'Graphite': '%23454343', 
    'Grey': '%23b4b5b9',
    'Hot Pink': '%23ff3eb5',
    'Ivory': '%23fffff0',
    'Lavender': '%238a8ccd',
    'Lime': '%2398DEB3',
    'Marlin Teal': '%2300aabe',
    'Maroon': '%23500000',
    'Navy': '%23041c2c',
    'Neon Green': '%2300FF00',
    'Neon Blue': '%23009cdd',
    'Neon Yellow': '%23fef900',
    'Neon Orange': '%23ff4300',
    'Neon Gold': '%23fef900',
    'Old Gold': '%23A19244',
    'Orange': '%23ff6e00',
    'Pink': '%23ffccd7',
    'Purple': '%2338187f',
    'Royal': '%23005cb0',
    'Scarlet': '%23CE1934',
    'Scarlet Red': '%23CE1934',
    'Sedona Red': '%23a80027',
    'Teal': '%23008587',
    'Tennessee Orange': '%23ff8b00',
    'Texas Orange': '%23d95400',
    'Turquoise': '%2300a0cf',
    'Vegas Gold': '%23d5cc9d',
    'White': '%23FAFAFA',
    'Yellow': '%23fffb7d',
    'Red': '%23a41c27',
    'Blue': '%2332479e',
    'Bubblegum Pink': '%23e27081',
    'Sky': '%23b3d7ff',
    'Kelly Green': '%2300a74a',
    'Kelly': '%2300a74a',
    'Forest': '%23005e35',
    'Silver': '%23b4b5b9',
    'Neon Pink': '%23ff3eb5',
    'Athletic Gold': '%23f6b81e',
    'Vegas': '%23cab155',
    'Olive': '%23394b35',
    'No Sock': '%23ffffff',
};

let customerPhoto;

function update_colors(toeText = "") {
    console.log('update_colors');

    let cc = '';

    if (customerPhoto) {
        cc = 'customerPhoto[https://socksrock.herokuapp.com/${customerPhoto}],';
    }

    if (cc) {
        const imageUrl = 'https://socks.liquifire.com/socks?set=${cc}toeText[${toeText}]&time=${new Date()}&call=url[%28%27file:socks/%27%20.%20%27global.style%27%29]&scale=size[500]&sink';
        $('#theImageA').attr('src', imageUrl);
        $("#product_pic").val(imageUrl);
    }
}

function set_pic(pic) {
    customerPhoto = pic;
    update_colors();  
}

jQuery(function() {
    $('#shappify_add_to_cart_btn').click(function() {
        if (!$('#awarecb').is(':checked')) {
            $('#aware-error').css('display', 'block');
            return false;        
        }
    });
    
    $('input#quantity[data-min]').change(function() {
        if (parseInt(this.value) < parseInt($(this).attr('data-min'))) {
            this.value = $(this).attr('data-min');
        }
    });
});

function watch(e) {
    let el = e;
    const intID = setInterval(function() {
        const display = $(el).css('display');
        let checker = $("input[name=sockstyle]").val();  
        checker = (checker != 'liquidfire') ? 'block' : 'none';

        if (display == checker) {
            $('select[name*="properties"]').each(function(index) {
                if (!$(this).val()) {
                    $(this).val($(this).find('option').eq(1).attr('value'));
                }
            });     
            update_colors();

            $('select[name*="properties"]').change(function() {
                update_colors();
            });
            
            let typingTimer;
            const doneTypingInterval = 1000;
            $('input[name="properties[Toe Text]"]').keyup(function(e) {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(function() {
                    update_colors(e.target.value);
                }, doneTypingInterval);

                update_colors(e.target.value);
            });

            clearInterval(intID);
        }
    }, 1000);
}

jQuery(function() {
    $("[id*='shappify_custom_options_']").each(function() { 
        console.log('this is running!')
        watch(this);
    });
});

function watch_exist(e) {
    let el = e;
    const intID = setInterval(function() { 
        // Check if el is a string (ID) or a jQuery object
        if (typeof el === 'string') {
            el = $('#' + el); // Select the element by ID
        } else if (el instanceof jQuery) {
            if (el.length > 0) {
                clearInterval(intID);
                console.log("Element with ID '" + el.attr('id') + "' exists.");
            }
        }
    }, 1000);
}

watch_exist('product-select-option-1');